<template>
    <div class="rates-dist-container">
        <div class="filter-title">
            <typo name="body-14-light">{{ label }} </typo>
        </div>
        <div class="search-rate-dist-cond-container">
            <v-select
                v-model="condition"
                :items="conditionItems"
                item-text="label"
                item-value="value"
                append-icon="mdi-chevron-down"
                dense
                outlined
                hide-details
                class="rounded-0"
            />
        </div>
        <div class="search-rate-dist-value-container">
            <v-text-field
                v-model="numberValue"
                hide-details
                single-line
                type="number"
                dense
                outlined
                class="rounded-0"
            />
        </div>
        <div class="search-rate-dist-unit-container">
            <v-select
                v-model="unit"
                :items="unitItems"
                item-text="label"
                item-value="code"
                append-icon="mdi-chevron-down"
                clearable
                dense
                outlined
                hide-details
                class="rounded-0"
            />
        </div>
    </div>
</template>

<script>
import { get } from "lodash";

export default {
    props: ["value", "label", "annotationOptions"],
    data() {
        return {
            numberValue: this.getNumberValue(),
            condition: this.getCondition(),
            unit: this.getUnit(),
            conditionItems: [
                { label: "=", value: "$eq" },
                { label: ">", value: "$gt" },
                { label: "<", value: "$lt" },
            ],
        };
    },
    methods: {
        getNumberValue() {
            if (this.value) {
                return this.value.numberValue;
            } else {
                return null;
            }
        },
        getUnit() {
            if (this.value) {
                return this.value.unit;
            } else {
                return null;
            }
        },
        getCondition() {
            if (this.value && this.value.condition) {
                return this.value.condition;
            } else {
                return "$eq";
            }
        },
    },
    watch: {
        async numberValue(value) {
            this.$emit("input", {
                numberValue: value,
                condition: this.condition,
                unit: this.unit,
            });
        },
        async condition(value) {
            this.$emit("input", {
                numberValue: this.numberValue,
                condition: value,
                unit: this.unit,
            });
        },
        async unit(value) {
            this.$emit("input", {
                numberValue: this.numberValue,
                condition: this.condition,
                unit: value,
            });
        },
        value(_value) {
            this.numberValue = _value ? _value.numberValue : null;
            this.condition = _value ? _value.condition : "$eq";
            this.unit = _value ? _value.unit : null;
        },
    },
    computed: {
        unitItems() {
            return Object.keys(this.annotationOptions)
                .map(key => {
                    return this.annotationOptions[key]["type"] === "unit"
                        ? {
                              code: key,
                              label: get(this.annotationOptions, `${key}.label`, "").toLowerCase(),
                          }
                        : null;
                })
                .filter(v => v !== null);
        },
    },
};
</script>

<style lang="sass" scoped>
.rates-dist-container
    display: flex
    align-items: center
    margin-bottom: 10px

.filter-title
    width: 140px

.search-rate-dist-cond-container
    width: 72px
    margin: 0 16px

.search-rate-dist-value-container
    width: 120px
    margin: 0 8px

.search-rate-dist-unit-container
    width: 200px
    margin: 0 8px
</style>
